import moment from 'moment';



export const DROP_DOWN = {
    "OnTimeExpirations": [
        { value: "autosubmit", label: "Open attempts are submitted automatically" },
        { value: "graceperiod", label: "There is a grace period when open attempts can be submitted, but no more questions answered" },
        { value: "autoabandon", label: "Attempts must be submitted before time expires, or they are not counted" },
    ],
    "AttemptsAllowed": [
        {
            "label": "Unlimited",
            "value": "0"
        },
        {
            "label": "1 Attempt",
            "value": "1"
        },
        {
            "label": "2 Attempts",
            "value": "2"
        },
        {
            "label": "3 Attempts",
            "value": "3"
        },
        {
            "label": "4 Attempts",
            "value": "4"
        },
        {
            "label": "5 Attempts",
            "value": "5"
        },
        {
            "label": "6 Attempts",
            "value": "6"
        }
    ],
    "GradeMethods": [
        {
            "label": "Highest grade",
            "value": 1
        },
        {
            "label": "Average grade",
            "value": 2
        },
        {
            "label": "First Attempt",
            "value": 3
        },
        {
            "label": "Last Attempt",
            "value": 4
        }
    ],
    "QuestionBehaviour": [
        {
            "label": "Adaptive mode",
            "value": "adaptive"
        },
        {
            "label": "Adaptive mode (No penalities)",
            "value": "adaptivenopenalty"
        },
        {
            "label": "Deferred feedback",
            "value": "deferredfeedback"
        },
        {
            "label": "Deferred feedback with CBM",
            "value": "deferredcbm"
        },
        {
            "label": "Immediate feedback",
            "value": "immediatefeedback"
        },
        {
            "label": "Immediate feedback with CBM",
            "value": "immediatecbm"
        },
        {
            "label": "Interactive with multiple tries",
            "value": "interactive"
        }
    ],
    "QuestionPerPage": [
        {
          "label": "All question in 1 page",
          "value": "0"
        },
        {
          "label": "1 question each page",
          "value": 1
        },
        {
          "label": "2 question each page",
          "value": 2
        },
        {
          "label": "3 question each page",
          "value": 3
        },
        {
          "label": "4 question each page",
          "value": 4
        },
        {
          "label": "5 question each page",
          "value": 5
        },
        {
          "label": "6 question each page",
          "value": 6
        },
        {
          "label": "7 question each page",
          "value": 7
        },
        {
          "label": "8 question each page",
          "value": 8
        },
        {
          "label": "9 question each page",
          "value": 9
        },
        {
          "label": "10 question each page",
          "value": 10
        },
        {
          "label": "Section wise",
          "value": 11
        }
      ],
      "DecimalQuestionGrades": [
        {
          "label": "Same as for overall grades",
          "value": "Same as for overall grades"
        },
        {
          "label": "0",
          "value": "0"
        },
        {
          "label": "1",
          "value": "1"
        },
        {
          "label": "2",
          "value": "2"
        },
        {
          "label": "3",
          "value": "3"
        },
        {
          "label": "4",
          "value": "4"
        },
        {
            "label": "5",
            "value": "5"
          },
          {
            "label": "6",
            "value": "6"
          },
          {
            "label": "7",
            "value": "7"
          }
      ],
      "Grade":[{
        "label":"Course total",
        "value":"Course total"
      }],
}
export interface QuizConfig {
    name: string;
    description: string;
    gradetype: string;
    examtype: string;
    subcomponentid: string;
    opentime: string;
    closetime: any;
    timelimit: number;
    overduehandling: string;
    totalmarks: number;
    gradetopass: number;
    grademethod: string;
    attemptallowed: number;
    overallfeedback: [];
    tags: [];
    questionsperpage: string;
    grade:string;
    decimalquestiongrades: any;
    navmethod: string;
    graceperiod: number;
    shuffleanswers: string;
    preferredbehaviour: string;
    canredoquestions: string;
    attemptonlast: string;
    attemptduring: string;
    correctnessduring: string;
    marksduring: string;
    specificfeedbackduring: string;
    generalfeedbackduring: string;
    rightanswerduring: string;
    overallfeedbackduring: string;
    attemptimmediately: string;
    correctnessimmediately: string;
    marksimmediately: string;
    specificfeedbackimmediately: string;
    generalfeedbackimmediately: string;
    rightanswerimmediately: string;
    overallfeedbackimmediately: string;
    attemptopen: string;
    correctnessopen: string;
    marksopen: string;
    specificfeedbackopen: string;
    generalfeedbackopen: string;
    rightansweropen: string;
    overallfeedbackopen: string;

    attemptclosed: string;
    correctnessclosed: string;
    marksclosed: string;
    specificfeedbackclosed: string;
    generalfeedbackclosed: string;
    rightanswerclosed: string;
    overallfeedbackclosed: string;

    showuserpicture: number;
    decimalpoints: number;
    questiondecimalpoints: number;
    showblocks: string;

    seb_requiresafeexambrowser: number;
    seb_showsebdownloadlink: string;
    seb_linkquitseb: string;
    seb_userconfirmquit: string;
    seb_allowuserquitseb: string;
    seb_quitpassword: string;
    seb_allowreloadinexam: string;
    seb_showsebtaskbar: string;
    seb_showreloadbutton: string;
    seb_showtime: string;
    seb_showkeyboardlayout: string;
    seb_showwificontrol: string;
    seb_enableaudiocontrol: string;
    seb_muteonstartup: string;
    seb_allowspellchecking: string;
    seb_activateurlfiltering: string;
    seb_allowedbrowserexamkeys: string;
    seb_filterembeddedcontent: string;
    seb_expressionsallowed?: string;
    seb_regexallowed?: string;
    seb_expressionsblocked?: string;
    seb_regexblocked?: string;

    quizpassword: string;
    subnet: string;
    delay1: number;
    delay2: number;
    browsersecurity: string;
    allowofflineattempts: string;
    proctoringrequired: string;
}

export function convertToSeconds(hours: number, minutes: number): number {
    return hours * 3600 + minutes * 60;
}

export const quizConfig = (): QuizConfig => {
    return {
        name: "",
        description: "",
        gradetype: "",
        examtype: "",
        subcomponentid: "",
        opentime: "",
        closetime: "",
        timelimit: 0,
        overduehandling: "autosubmit",
        totalmarks: 0,
        gradetopass: 0,
        grademethod: "1",
        attemptallowed: 0,
        overallfeedback: [],
        tags: [],
        questionsperpage: "0",
        navmethod: "free",
        graceperiod: 0,
        shuffleanswers: "0",
        preferredbehaviour: "adaptive",
        decimalquestiongrades: "Same as for overall grades",
        canredoquestions: "0",
        attemptonlast: "0",
        grade:"",
        attemptduring: "1",
        correctnessduring: "1",
        marksduring: "1",
        specificfeedbackduring: "0",
        generalfeedbackduring: "1",
        rightanswerduring: "0",
        overallfeedbackduring: "1",

        attemptimmediately: "1",
        correctnessimmediately: "0",
        marksimmediately: "1",
        specificfeedbackimmediately: "0",
        generalfeedbackimmediately: "0",
        rightanswerimmediately: "0",
        overallfeedbackimmediately: "1",

        attemptopen: "1",
        correctnessopen: "1",
        marksopen: "1",
        specificfeedbackopen: "0",
        generalfeedbackopen: "0",
        rightansweropen: "0",
        overallfeedbackopen: "0",

        attemptclosed: "1",
        correctnessclosed: "0",
        marksclosed: "0",
        specificfeedbackclosed: "0",
        generalfeedbackclosed: "1",
        rightanswerclosed: "0",
        overallfeedbackclosed: "1",

        showuserpicture: 1,
        decimalpoints: 2,
        questiondecimalpoints: 1,
        showblocks: "0",

        seb_requiresafeexambrowser: 0,
        seb_showsebdownloadlink: "0",
        seb_linkquitseb: "",
        seb_userconfirmquit: "1",
        seb_allowuserquitseb: "0",
        seb_quitpassword: "",
        seb_allowreloadinexam: "1",
        seb_showsebtaskbar: "0",
        seb_showreloadbutton: "1",
        seb_showtime: "1",
        seb_showkeyboardlayout: "0",
        seb_showwificontrol: "0",
        seb_enableaudiocontrol: "1",
        seb_muteonstartup: "0",
        seb_allowspellchecking: "1",
        seb_activateurlfiltering: "0",
        seb_allowedbrowserexamkeys: "",
        seb_filterembeddedcontent: "0",
        seb_expressionsallowed: "",
        seb_regexallowed: "",
        seb_expressionsblocked: "",
        seb_regexblocked: "",

        quizpassword: "",
        subnet: "",
        delay1: 0,
        delay2: 0,
        browsersecurity: "",
        allowofflineattempts: "0",
        proctoringrequired: "0"
    }
} 
